import React from "react";
import MulSelector from "../TeaSelector/MultipleSelector";
import { useIntl } from "umi";

export default function ChannelTypeAll(props: any) {
  const {
    onConfirm,
    value = [],
  } = props;

  const { formatMessage } = useIntl();

  const gameType = [
    {
      value: 'Game Store',
      text: formatMessage({ id: 'dbi-sm-filter-gamestore' }),
      buttonText: formatMessage({ id: 'dbi-sm-filter-gamestore' }),
    },
    {
      value: 'Social Media',
      text: formatMessage({ id: 'dbi-sm-filter-socialmedia' }),
      buttonText: formatMessage({ id: 'dbi-sm-filter-socialmedia' }),
    },
    {
      value: 'Streaming',
      text: formatMessage({ id: 'dbi-sm-filter-streaming' }),
      buttonText: formatMessage({ id: 'dbi-sm-filter-streaming' }),
    },
  ]

  const handleChange = (values: string[] | string) => {
    if (onConfirm instanceof Function) {
      onConfirm(values);
    }
  };

  return (
    <MulSelector
      value={typeof value === 'string' ? [] : value}
      options={gameType}
      buttonName={formatMessage({ id: 'dbi-sm-filter-channeltype' })}
      onChange={handleChange}
    />
  )
}